// Shared by Tab (deriving a tab's DOM id from its name) and Tabs (deriving a
// turbo-frame id). Both need the same transform, so it lives in one place
// rather than being reimplemented either side.
export const slugify = (value: string): string => value.trim().toLowerCase().replace(/\s+/g, "-");
